<template>
  <!-- eslint-disable vue/no-v-html -->
  <component
    :is="type"
    :class="[$style.BaseIcon, $style[`BaseIcon--${size}`]]"
    v-bind="$attrs"
    v-html="svg"
  />
</template>
<script>
export default {
  props: {
    size: {
      type: String,
      default: 'm',
      validator: value => value.match(/^(xxs|xs|sm|m|lg|xl|xxl)$/)
    },
    name: {
      type: String,
      required: false,
      default: ''
    },
    type: {
      type: String,
      default: 'span'
    },
    titleTranslation: {
      type: String,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    svg() {
      const svg = require(`!svg-inline-loader!../assets/icons/${this.name}.svg`);
      const doc = new DOMParser().parseFromString(svg, 'text/xml');
      if (this.fill) {
        doc.querySelectorAll('path, g, circle').forEach(p => {
          p.setAttribute('style', `fill: ${this.fill}`);
        });
      }
      let svg_title = doc.querySelector('title');
      if (svg_title !== null) {
        let trans = `icons.${this.name}`;
        if (this.titleTranslation !== '') {
          trans = this.titleTranslation;
        }
        svg_title.innerHTML = this.$i18n.t(trans);
      }
      return doc.documentElement.outerHTML;
    }
  }
};
</script>
<style lang="scss" src="../scss/components/BaseIcon.scss" module></style>
